import { createSlice } from "@reduxjs/toolkit";
import {
  DEFAULT_EMPLOYEE_TRADES_DATE_TYPE_FILTER,
  DEFAULT_EMPLOYEE_TRADES_MOBILE_SORT_BY_VALUE,
  DEFAULT_EMPLOYEE_TRADES_SORT_MODEL,
  DEFAULT_EMPLOYEE_TRADES_STATUS_FILTERS,
  DEFAULT_EMPLOYEE_TRADES_TRADE_TYPE_FILTERS,
  DEFAULT_EMPLOYEE_TRADES_WORKGROUP_FILTERS
} from "../../util/filterTrades";

const initialState = {
  isMobileFilterDialogOpen: false,
  mobileSortByValue: DEFAULT_EMPLOYEE_TRADES_MOBILE_SORT_BY_VALUE,
  dateTypeFilter: DEFAULT_EMPLOYEE_TRADES_DATE_TYPE_FILTER,
  startDateFilter: null,
  endDateFilter: null,
  tradeTypeFilters: DEFAULT_EMPLOYEE_TRADES_TRADE_TYPE_FILTERS,
  statusFilters: DEFAULT_EMPLOYEE_TRADES_STATUS_FILTERS,
  workgroupFilters: DEFAULT_EMPLOYEE_TRADES_WORKGROUP_FILTERS,
  searchString: "",
  tradeFoundByReferenceNumberSearch: null,
  tradeFoundByReferenceNumberSearchIsLoading: false,
  tradeFoundByReferenceNumberSearchIsDialogOpen: false,
  searchStringErrors: "",
  startDateFilterErrors: "",
  endDateFilterErrors: "",
  sortModel: DEFAULT_EMPLOYEE_TRADES_SORT_MODEL,
};

// The plan is that this slice will be the home of all trade related data in the client
// including the following:
//      - trade filter metadata
//      - trade list (future)
//      - filtered trade list (future)
//      - searched trade list (future)
export const employeeTradeSlice = createSlice({
  name: "employeeTrade",
  initialState,
  reducers: {
    updateIsMobileFilterDialogOpen: (state, action) => {
      state.isMobileFilterDialogOpen = action.payload;
    },
    updateMobileSortByValue: (state, action) => {
      state.mobileSortByValue = action.payload;
    },
    updateDateTypeFilter: (state, action) => {
      state.dateTypeFilter = action.payload;
    },
    updateStartDateFilter: (state, action) => {
      state.startDateFilter = action.payload;
    },
    updateEndDateFilter: (state, action) => {
      state.endDateFilter = action.payload;
    },
    updateTradeTypeFilters: (state, action) => {
      state.tradeTypeFilters = action.payload;
    },
    updateStatusFilters: (state, action) => {
      state.statusFilters = action.payload;
    },
    updateWorkgroupFilters: (state, action) => {
      state.workgroupFilters = action.payload;
    },
    updateSearchString: (state, action) => {
      state.searchString = action.payload;
    },
    updateTradeFoundByReferenceNumberSearch: (state, action) => {
      state.tradeFoundByReferenceNumberSearch = action.payload;
    },
    updateTradeFoundByReferenceNumberSearchIsLoading: (state, action) => {
      state.tradeFoundByReferenceNumberSearchIsLoading = action.payload;
    },
    updateTradeFoundByReferenceNumberSearchIsDialogOpen: (state, action) => {
      state.tradeFoundByReferenceNumberSearchIsDialogOpen = action.payload;
    },
    updateSearchStringErrors: (state, action) => {
      state.searchStringErrors = action.payload;
    },
    updateStartDateFilterErrors: (state, action) => {
      state.startDateFilterErrors = action.payload;
    },
    updateEndDateFilterErrors: (state, action) => {
      state.endDateFilterErrors = action.payload;
    },
    updateSortModel: (state, action) => {
      state.sortModel = action.payload;
    },
    clearAllTradeFilters: () => initialState,
  },
});

export const {
  updateIsMobileFilterDialogOpen,
  updateMobileSortByValue,
  updateDateTypeFilter,
  updateStartDateFilter,
  updateEndDateFilter,
  updateTradeTypeFilters,
  updateStatusFilters,
  updateWorkgroupFilters,
  updateSearchString,
  updateTradeFoundByReferenceNumberSearch,
  updateTradeFoundByReferenceNumberSearchIsLoading,
  updateTradeFoundByReferenceNumberSearchIsDialogOpen,
  updateSearchStringErrors,
  updateStartDateFilterErrors,
  updateEndDateFilterErrors,
  updateSortModel,
  clearAllTradeFilters,
} = employeeTradeSlice.actions;

export const selectEmployeeTradeData = (state) => state.employeeTrade;

export default employeeTradeSlice.reducer;
